import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Input,
	ViewChild,
	OnDestroy,
	Output,
	EventEmitter,
} from "@angular/core";
import { SharedService } from "../../../shared/sharedServices/shared.service";
import { HecResponse } from "../../../shared/shared-interfaces/hecResponse";
import { HEC_CONSTANTS } from "../../../utilities/constants";
import { NgForm, FormGroup, FormBuilder, FormArray, FormControl } from "@angular/forms";
import { MatDialog, MatSnackBar } from "@angular/material";
import { QuestionnaireComponent } from "../../../shared/shared-components/modal/questionnaire/questionnaire.component";
import { EducationService } from "./services/education.service";
import { decrypt, encrypt } from "../../../utilities/utilityFunctions";
import { Router } from "@angular/router";
import { LoaderService } from "../../../shared/sharedServices/loader.service";
import { GoogleAnalyticsService } from "../../../shared/sharedServices/google-analytics.service";
import { UploadAdditionalDocumentsService } from "../../../shared/shared-components/upload-additional-documents/services/upload-additional-documents.service";
import { AttestationModel } from "../../../shared/shared-models/attestationModel";
import { EligibilityModel } from '../../../shared/shared-models/eligibility-model';
import { AppFormDataService } from '../../sharedServices/app-form-data.service';
@Component({
	selector: "kt-shared-education",
	templateUrl: "./education.component.html",
	styleUrls: ["./education.component.scss"],
})
export class EducationComponent implements OnInit, OnDestroy {
	public loader: boolean = false;
	public commentsList: Array<any>;
	public formViewType: any;
	public educationDetailsData: any = [];
	public educationDetailGridData: any = [];
	public viewform: boolean = false;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public dateError: string = "";
	public educationDetailsGridDetails: any;
	public selectedEducation: any;
	public commonProfileId: string;
	@Output() educationData = new EventEmitter();
	public eduForm: FormGroup;
	@Input("dropdownValuesForDas") dropdownValuesForDas: any;
	@Input("dropdownList") dropdownList: any;
	public formType: string = "das";
	public alertType: string;
	public formView: string = "";
	public eduTableLoader: boolean = false;
	@Input("dasApplicationData")
	dasApplicationData: AttestationModel = new AttestationModel();
	@Output() updateDasAppData = new EventEmitter();
	requiredStream: any;
	educationHistory: any;
	sscAvailable: boolean;
	hscAvailable: boolean;
	@Output() nextComponent = new EventEmitter();
	@Output() prevComponent = new EventEmitter();

	@Input('processAcronym') processAcronym: string;

	constructor(
		private sharedServices: SharedService,
		private cdr: ChangeDetectorRef,
		private fb: FormBuilder,
		private gaService: GoogleAnalyticsService,
		private router: Router,
		private loaderService: LoaderService,
		private appFormData: AppFormDataService,
		private matDialog: MatDialog,
		private educationServices: EducationService,
		public _snackBar: MatSnackBar,
		private uploadAdditionalService: UploadAdditionalDocumentsService,
	) {
		if (localStorage.getItem("edu")) {
			this.selectedEducation = JSON.parse(
				decrypt(localStorage.getItem("edu"))
			);
		}
		let data = decrypt(localStorage.getItem("esp-profile-details"));
		data = JSON.parse(data);
		this.commonProfileId = data["profileId"];
		this.createEducationForm();
	}
	async ngOnInit() {
		window.scroll(0, 0);
		this.gaService.setPage("/form", "ESP Page");
		console.log("form data ipfp: ", this.appFormData);
		
		this.formView = this.appFormData.formView;
		if (this.appFormData.isAdmin) await this.getEducationDetailsAdmin(this.appFormData.application.commonProfileId);
		else await this.getEducationDetails();

		console.log("acronym: ", this.processAcronym);
		
			// IPFP
		// const stored = localStorage.getItem('ipfpData');
		// if (stored) {
		// 	const appFormDataService = JSON.parse(stored);
		// 	console.log("Form view inside IPFP Education: ", appFormDataService);

		// 	this.formType = appFormDataService.formView;
		// 	this.formViewType = appFormDataService.formView;
		// 	this.processAcronym = appFormDataService.acronym;
		// 	// debugger
		// }
	}
	ngOnDestroy() {
		this.appFormData.formView = undefined;
		this.appFormData.applicationId = undefined;
		localStorage.removeItem("edu");
	}
	private createEducationForm(): void {
		this.eduForm = this.fb.group({
			eduDtoList: this.fb.array([]),
		});
	}
	public getEducationList(): any {
		return this.eduForm.controls.eduDtoList["controls"];
	}
	public addNewEdu(data): void {
		const eduValues = this.eduForm.controls.eduDtoList as FormArray;
		let newRow = this.fb.group({
			isChecked: new FormControl(),
			eduId: new FormControl(data.educationId ? data.educationId : null),
			eduHistoryId: new FormControl(
				data.eduationHistoryId ? data.eduationHistoryId : null
			),
			universityName: new FormControl(
				data.universityName ? data.universityName : ""
			),
			degreeProgramName: new FormControl(
				data.countryId == 1
					? data.degreeProgramName
					: data.otherProgramTitle
			),
		});
		eduValues.push(newRow);
	}
	public deleteEducationRow(eduInd): void {
		const eduForm = this.eduForm.controls.eduDtoList as FormArray;
		eduForm.removeAt(eduInd);
		this.eduForm.value.eduDtoList--;
	}
	public getEducationDetails() {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.eduTableLoader = true;
		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			this.deleteEducationRow(0);
		}
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.cdr.detectChanges();
		this.sharedServices.getEducationDetails().subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.educationDetailsGridDetails = res.data;
					for (let i = 0; i < res.data.length; i++) {
						this.educationDetailGridData.push(res.data[i]);
						this.addNewEdu(res.data[i]);
					}
					if (this.selectedEducation) {
						for (
							let i = 0;
							i < this.educationDetailGridData.length;
							i++
						) {
							if (
								this.selectedEducation.educationId ==
								this.educationDetailGridData[i].educationId
							) {
								this.eduForm.controls.eduDtoList["controls"][
									i
								].controls.isChecked.patchValue(true);
							}
						}
					} else if (
						this.dasApplicationData.dasApplicationDto
							.commonProfileId &&
						this.dasApplicationData.dasApplicationDto.dasDegrees
							.length > 0
					) {
						for (
							let i = 0;
							i <
							this.dasApplicationData.dasApplicationDto.dasDegrees
								.length;
							i++
						) {
							for (
								let j = 0;
								j < this.educationDetailGridData.length;
								j++
							) {
								if (
									this.dasApplicationData.dasApplicationDto
										.dasDegrees[i].educationHistoryDto
										.educationId ==
									this.educationDetailGridData[j].educationId
								) {
									this.eduForm.controls.eduDtoList[
										"controls"
									][j].controls.isChecked.patchValue(true);
								}
								this.commentsList.forEach((element, index) => {
									if (
										element.degreeId ==
										this.dasApplicationData
											.dasApplicationDto.dasDegrees[i]
											.cpEducationHistoryId
									) {
										this.commentsList[
											index
										].eduId = this.dasApplicationData.dasApplicationDto.dasDegrees[
											i
										].educationHistoryDto.educationId;
									}
								});
							}
						}
					}

					this.eduTableLoader = false;
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.eduTableLoader = false;
				this.cdr.detectChanges();
			}
		);
		if (this.formView == "view") {
			setTimeout(() => {
				this.eduForm.disable();
				this.eduForm.controls.eduDtoList.disable();
			}, 1000);
		}
		setTimeout(() => {
			this.educationDetailGridData.forEach((element, index) => {
				if (element.countryId != 1 && element.isCurrentEnrolment) {
					setTimeout(() => {
						this.eduForm.controls.eduDtoList["controls"][
							index
						].controls.isChecked.disable();
					}, 500);
				}
			});
		}, 500);
	}

	public getEducationDetailsAdmin(id) {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.eduTableLoader = true;
		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			this.deleteEducationRow(0);
		}
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.cdr.detectChanges();
		this.sharedServices.getPersonalDetailsAdmin(id).subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.educationDetailsGridDetails = res.data.education;
					for (let i = 0; i < res.data.education.length; i++) {
						this.educationDetailGridData.push(res.data.education[i]);
						this.addNewEdu(res.data.education[i]);
					}
					if (this.selectedEducation) {
						for (
							let i = 0;
							i < this.educationDetailGridData.length;
							i++
						) {
							if (
								this.selectedEducation.educationId ==
								this.educationDetailGridData[i].educationId
							) {
								this.eduForm.controls.eduDtoList["controls"][
									i
								].controls.isChecked.patchValue(true);
							}
						}
					} else if (
						this.dasApplicationData.dasApplicationDto
							.commonProfileId &&
						this.dasApplicationData.dasApplicationDto.dasDegrees
							.length > 0
					) {
						for (
							let i = 0;
							i <
							this.dasApplicationData.dasApplicationDto.dasDegrees
								.length;
							i++
						) {
							for (
								let j = 0;
								j < this.educationDetailGridData.length;
								j++
							) {
								if (
									this.dasApplicationData.dasApplicationDto
										.dasDegrees[i].educationHistoryDto
										.educationId ==
									this.educationDetailGridData[j].educationId
								) {
									this.eduForm.controls.eduDtoList[
										"controls"
									][j].controls.isChecked.patchValue(true);
								}
								this.commentsList.forEach((element, index) => {
									if (
										element.degreeId ==
										this.dasApplicationData
											.dasApplicationDto.dasDegrees[i]
											.cpEducationHistoryId
									) {
										this.commentsList[
											index
										].eduId = this.dasApplicationData.dasApplicationDto.dasDegrees[
											i
										].educationHistoryDto.educationId;
									}
								});
							}
						}
					}

					this.eduTableLoader = false;
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.eduTableLoader = false;
				this.cdr.detectChanges();
			}
		);
		if (this.formView == "view") {
			setTimeout(() => {
				this.eduForm.disable();
				this.eduForm.controls.eduDtoList.disable();
			}, 1000);
		}
		setTimeout(() => {
			this.educationDetailGridData.forEach((element, index) => {
				if (element.countryId != 1 && element.isCurrentEnrolment) {
					setTimeout(() => {
						this.eduForm.controls.eduDtoList["controls"][
							index
						].controls.isChecked.disable();
					}, 500);
				}
			});
		}, 500);
	}

	public async getDasComments(appId): Promise<any> {
		if (appId) {
			try {
				this.loader = true;
				this.loaderService.setValue(this.loader);
				const res = await this.uploadAdditionalService
					.getDasComments(appId)
					.toPromise();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.commentsList = [];
					res.data.forEach((element) => {
						if (element.degreeId) {
							this.commentsList.push(element);
						}
					});

					this.loader = false;
					this.loaderService.setValue(this.loader);
				} else {
				}
			} catch (err) {
				this.loader = false;
				this.loaderService.setValue(this.loader);
			}
		}
	}
	public goNext() {
		if (this.formView == 'view') {
			this.nextComponent.emit(true);
			if (!this.cdr["destroyed"]) this.cdr.detectChanges();
		}
		else {
			if (this.processAcronym != 'IPFP') {
				this.checkEligibility()
			} else {
				this.nextComponent.emit(true);
			}
		}
	}
	public goBack() {
		this.prevComponent.emit(true);
		this.cdr.detectChanges();
	}
	public async openEducationDetails(data, index, type) {
		this.formViewType = type;
		this.educationDetailsData = data;
		this.viewform = true;
		this.cdr.detectChanges();
		if (type == "view") {
			this._snackBar.open(
				"You're in view mode! To exit, please click Cancel button to continue with your Application Form",
				"",
				{
					duration: 9500,
					panelClass: ["error-snackbar"],
				}
			);
		} else if (type == "edit") {
			this._snackBar.open(
				"You're in edit mode! To exit, please click Cancel button to continue with your Application Form",
				"",
				{
					duration: 9500,
					panelClass: ["error-snackbar"],
				}
			);
		}
	}
	public deleteEducation(educationData) {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		educationData.activeIndicator = false;
		let payload = {
			data: educationData,
		};
		this.educationServices.saveOrUpdateEducation(payload).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.getEducationDetails();
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.isAlertVisible = true;
					this.alertType = "error";
					this.alertMsgValue = "Error in deleting Education";
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.isAlertVisible = true;
				this.alertType = "error";
				this.alertMsgValue = "Error in deleting Education";
				this.cdr.detectChanges();
			}
		);
	}
	public getDate(date): any {
		let convertedDate = new Date(date).toISOString();
		return convertedDate;
	}
	public getCommentDate(date): void {
		return this.sharedServices.getDate(date);
	}
	public addNewEducation() {
		this.formViewType = "new";
		this.educationDetailsData = [];
		this.viewform = true;
		this.cdr.detectChanges();
		this.cdr.markForCheck();
	}

	public getUpdatedEducation(educationStatus) {
		this.viewform = false;
		this.isAlertVisible = true;
		this.formViewType = undefined;
		if (educationStatus.id) {
			this.alertType = "success";
			this.alertMsgValue = "Education Update Successfully";
		} else {
			this.alertType = "success";
			this.alertMsgValue = "Education Added Successfully";
		}
		this.getEducationDetails();
		setTimeout(() => {
			this.isAlertVisible = false;
			this.cdr.detectChanges();
		}, 3000);
	}
	public async submitEducation(type) {
		if (type == "next") {
			this.goNext();
		} else if (type == "save") {
			this.router.navigate(["/dashboard"]);
		}
	}
	public submitQuestionnaire(): void { }
	private constructPayload() {
		let eduDetails = [];

		for (let i = 0; i < this.eduForm.value.eduDtoList.length; i++) {
			if (
				this.educationDetailGridData[i].educationId ==
				this.eduForm.value.eduDtoList[i].eduId
			) {
				eduDetails[i] = this.educationDetailGridData[i];
			}
		}
		let payload = {
			data: eduDetails,
		};

		return payload;
	}
	public getDasFormDate() {
		return new Promise((resolve, reject) => {
			this.loader = true;
			this.loaderService.setValue(this.loader);
			this.educationServices.getPucaFormDetails().subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (
							this.dasApplicationData.dasApplicationDto
								.isQuestionnaireFilled == undefined
						) {
							this.ModalComponent(
								QuestionnaireComponent,
								res.data.dasQuestionnaireDtoList
							);
						} else if (
							this.dasApplicationData.dasApplicationDto
								.isQuestionnaireFilled
						) {
							this.goNext();
						}
					} else {
					}
				},
				(err) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
				}
			);
		});
	}
	public ModalComponent(Component, data) {
		const dialogRef = this.matDialog.open(Component, {
			width: "80vw",
			height: "70vh",
			backdropClass: "custom-scrutiny-popups",
			panelClass: "custom-scrutiny-popups",
			disableClose: true,
			autoFocus: false,
			data: { questions: data },
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.submitQuestionnaire();
			} else {
				localStorage.setItem("questionnaire", encrypt("return"));
				this.router.navigate(["/dashboard"]);
			}
		});
	}
	public cancelEducation(event) {
		if (event == "cancel") {
			this.formViewType = undefined;
			this.viewform = false;
			this.cdr.detectChanges();
		}
	}
	public cancelAttestaion() {
		if (this.appFormData.isAdmin) {
			this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
		}
		else {
			this.router.navigate(['/'])
		}
	}


	private async checkEligibility() {
		let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		const res: any = await this.sharedServices.checkEligibility(data['profileId'], this.processAcronym).toPromise();
		if (res.code == 0) {
			let eligibility: EligibilityModel = new EligibilityModel();
			eligibility = res.result;
			this.educationDetailGridData.forEach(element => {
				this.requiredStream = this.educationStreams[element.qualificationId]
			});
			for (let i = 0; i < this.educationDetailGridData.length; i++) {
				if (!this.educationDetailGridData[i].division) {
					this.alertMsgValue = "Please edit your education and enter your CGPA/Marks details ";
					this.alertType = 'error';
					this.isAlertVisible = true;
					return false;
				}
				if (this.educationDetailGridData[i].qualificationId == 7) {
					this.sscAvailable = true
				}
				if (this.educationDetailGridData[i].qualificationId == 8) {
					this.hscAvailable = true
				}
			}

			if (!this.hscAvailable || !this.sscAvailable) {
				this.alertMsgValue = 'Please enter HSC && SSC Education.';
				// this.alertMsgValue = 'You have missed some education records in your educational track. Please fill in the gaps and provide complete education track record from lowest to highest education.';
				this.alertType = 'error';
				this.isAlertVisible = true;
				return false;
			}
			let isRequiredEducationAvailable = [];
			if (this.requiredStream && this.requiredStream.length > 0) {
				for (let i = 0; i < this.requiredStream.length; i++) {
					isRequiredEducationAvailable[i] = false;
					for (let j = 0; j < this.educationDetailGridData.length; j++) {
						if (this.educationDetailGridData[j].qualificationLevel == this.requiredStream[i].label) {
							isRequiredEducationAvailable[i] = true;
						}
					}
				}

				let isEducationValid = (this.requiredStream.length > 0) ? false : true;
				if (this.appFormData && this.appFormData.acronym == "PUCA") {
					for (let i = 0; i < isRequiredEducationAvailable.length; i++) {
						if (isRequiredEducationAvailable[i]) isEducationValid = true;
					}
				}
				else {
					isEducationValid = true;
				}

				if (!isEducationValid) {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'You have missed some education records in your educational track. Please fill in the gaps and provide complete education track record from lowest to highest education.'
					return false;
				}

			}
			if (!eligibility.isMinimunEdu) {
                this.isAlertVisible = true;
                this.alertType = 'error';
                // this.alertMsgValue = "You should be currently enrolled in a PHD program to proceed further."
                this.alertMsgValue = "Minimum education: 16–18 years degree and currently enrolled in PhD."
				return false;
			}
			if (eligibility.isEducation && eligibility.isMinimunEdu && eligibility.is3rdDivision && eligibility.is2ndDivision) {
				this.nextComponent.emit(true);
				if (!this.cdr["destroyed"]) this.cdr.detectChanges();
			}

			else {
				if (eligibility.isEducation && eligibility.isMinimunEdu && eligibility.is3rdDivision && !eligibility.is2ndDivision) {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'You do not meet the following criteria: Maximum two 2nd Divisions are allowed'
					return false;
				}
				else if (eligibility.isEducation && eligibility.isMinimunEdu && !eligibility.is3rdDivision && eligibility.is2ndDivision) {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'You should not have any 3rd division in your entire academic career'
					return false;
				}
				else if (!eligibility.isEducation && eligibility.isMinimunEdu && eligibility.is3rdDivision && eligibility.is2ndDivision) {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'You should not have any 3rd division in your entire academic career'
					return false;
				}
				else {
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'You have missed some education records in your educational track. Please fill in the gaps and provide complete education track record from lowest to highest education.'
					return false;
				}


			}
		}
	}

	public educationStreams: any = {
		9: [],
		14: [],
		10: [],
		15: [{ id: 9, label: 'Bachelor (14 Years) Degree' }, { id: 14, label: 'Bachelor (15 Years) Degree' }],
		16: [{ id: 10, label: 'Bachelor (16 Years) Degree' }, { id: 14, label: 'Master (16 Years) Degree' }],
		11: [{ id: 10, label: 'Bachelor (16 Years) Degree' }, { id: 14, label: 'Master (16 Years) Degree' }],
		17: [{ id: 10, label: 'Bachelor (16 Years) Degree' }, { id: 14, label: 'Master (16 Years) Degree' }],
		19: [{ id: 10, label: 'Bachelor (16 Years) Degree' }, { id: 14, label: 'Master (16 Years) Degree' }],
		12: [{ id: 17, label: 'M-Phil (18 Years) Degree' }, { id: 11, label: 'Master/ MS (18 Years) Degree' }],
		20: [{ id: 9, label: 'Bachelor (14 Years) Degree' }]

	}
}
